import {useTranslation} from "react-i18next";
import React from "react";
import {Control} from "react-hook-form";
import {Grid} from "@mui/material";
import FileDropZone from "../../common/components/upload/FileDropZone";
import {MAX_CSV_FILE_SIZE} from "../../phonebook";
import {UseFormGetFieldState, UseFormSetValue} from "react-hook-form/dist/types/form";
import FormCheckbox from "../../common/form/FormCheckbox";

type Props = {
    index: number
    control: Control<any>
    setValue: UseFormSetValue<any>
    getFieldState: UseFormGetFieldState<any>
    onFileUploaded?: (file: File) => void
}


export const PhoneBookForm = ({ index, control, setValue, getFieldState, onFileUploaded  }: Props) => {
    const { t } = useTranslation()

    return (<Grid container mt={2} spacing={2}>
        <Grid item>
            <FormCheckbox
                label={t('phonebook.clear-existing-entries')}
                name={`fieldUpdates.${index}.values.0.selected`}
                control={control}
                setValue={setValue}
                getFieldState={getFieldState}
            />
        </Grid>
        <Grid item>
            <FileDropZone
                uploadUrl={null}
                onFileUploaded={onFileUploaded || ((file) => {})}
                acceptMime=".csv"
                maxSizeInBytes={MAX_CSV_FILE_SIZE}
                dropzoneTitle={t('phonebook.import-csv-dropzone-title')}
                showSuccess={true}
            />
        </Grid>
    </Grid>)
}